import { createAction, props } from '@ngrx/store';
import { Dictionary } from 'src/app/shared/types/dictionary';

export enum AnalyticsCheckoutStep {
	PAYMENT_SELECTION_PAGE = 1,
	SELECT_PAYMENT = 2,
	STANDARD_CREDIT_CARD_PAGE = 3,
}

export const sendToGtag = createAction('[Analytics] Gtag', props<{ params: any[] }>());

export const sendAnalyticsEventAction = createAction(
	'[Analytics] Send Event',
	props<{ action: string; data?: Dictionary<string> }>()
);
